/**
 * HTTP header constants used in API service fetch calls.
 */

export const HTTP_HEADERS = {
  CONTENT_TYPE_JSON: { "Content-Type": "application/json" },
} as const;

/** Build Authorization header from token */
export const authHeader = (token: string) => ({
  Authorization: `Bearer ${token}`,
});

/** Build full headers for JSON POST/PUT requests */
export const jsonAuthHeaders = (token: string) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});
